import { GItem } from "./GItem";
import { NItem } from "./NItem";
import { SItem } from './SItem';
import { CommonFunctions } from "../static/common-functions";

export class RequestTimeOffReference {
  constructor(data: RequestTimeOffReference = null) {
      if (data !== null) {
          this.timeAllOffTypes = data.timeAllOffTypes
          this.timeOffStatuses = data.timeOffStatuses
          this.timeOffTypes = data.timeOffTypes
          this.timeOffHours = data.timeOffHours
          this.timeOffMins = data.timeOffMins 
          this.timeOffLongTypes = data.timeOffLongTypes;

    }
  }
  timeOffStatuses: NItem[] = null;
  timeAllOffTypes: NItem[] = null;
  timeOffTypes: GItem[] = null;
  timeOffHours: NItem[] = null;
    timeOffMins: NItem[] = null;
    timeOffLongTypes: GItem[] = null;

    getTimeOffTypeDesc(id: any): string {
        if (this.timeOffTypes) {
            let item = this.timeAllOffTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
}
